var planodiretor = {
	templateUrl: './plano-diretor.html',
	controller: 'PlanoDiretorController',
	controllerAs: 'vm'
};

angular
	.module('components.planodiretor')
	.component('planodiretor', planodiretor)
	.config(function ($stateProvider, $urlRouterProvider) {
		$stateProvider
			.state('planodiretor', {
				parent: 'app',
				url: '/cliente/:slug/planodiretor',
				component: 'planodiretor',
				resolve: {}
			});
	});
